<template>
  <div class="container">
    <div class="nav-img">
      <img v-if="url.indexOf('shian360.com') != -1" src="@/assets/stlogo.png" />
      <img v-else src="@/assets/cqqlogo.png" />
      <!-- <div class="logo-title">菜圈圈科技</div> -->
      <div class="nav-btn">
        <el-button type="primary" @click="login()">首页</el-button>
        <!-- <el-button type="primary" @click="openHonme()" v-if="token==null">没有账号，注册</el-button> -->
      </div>
    </div>
    <div class="form-con">
      <div class="release-title">产品发布</div>
      <el-row>
        <el-col :span="16">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="信息分类" prop="category_id">
              <el-select v-model="ruleForm.category_id" placeholder="请选择产品分类" @change="changesetre">
                <el-option v-for="item in productData" :label="item.name" :value="item.name" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品标题" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="商品图片" prop="img_ids">
              <el-upload
                :action="url"
                list-type="picture-card"
                v-model="ruleForm.img_ids"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :headers="headers"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="商品简介" prop="intro">
              <el-input type="textarea" v-model="ruleForm.intro" autosize></el-input>
            </el-form-item>
            <el-form-item label="产品详情">
              <editor-bar v-model="detail" :isClear="isClear" @change="change"></editor-bar>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="ruleForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import EditorBar from './editoritem'
import { proModuleApi } from '@/api/home'
export default {
  components: { EditorBar },
  data() {
    return {
      token: '',
      url: process.env.VUE_APP_BASE_URL + '/basic/upload/image',
      dialogImageUrl: '',
      dialogVisible: false,
      productData: [],
      headers: {},
      ruleForm: {
        category_id: '',
        name: '',
        memo: '',
        img_ids: [],
        password: ''
      },
      categoryId: '',
      rules: {
        category_id: [
          {
            required: true,
            message: '商品分类不能为空',
            trigger: 'blur'
          }
        ],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        intro: [{ required: true, message: '请填写商品简介', trigger: 'blur' }],
        img_ids: [{ required: true, message: '请上传最少一张图片', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入不少于3位的密码', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15个字符', trigger: 'blur' }
        ]
      },
      isClear: false,
      detail: '',
      url: ''
    }
  },
  created() {
    this.url = window.location.hostname
    this.token = sessionStorage.getItem('token')
    if (!this.token) {
      this.$router.push({
        path: '/login'
      })
    }
    this.headers.token = this.token
    this.getCategoryAll()
  },
  methods: {
    getCategoryAll() {
      proModuleApi
        .getCategory()
        .then(res => {
          this.productData = res.data
        })
        .catch()
    },
    changesetre(val) {
      if (val) {
        let obj = []
        obj = this.productData.filter(item => item.name == val)
        this.categoryId = obj[0].id
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm
          // console.log(this.ruleForm)
          params.category_id = this.categoryId
          // console.log(params)
          proModuleApi
            .releasePro(params)
            .then(res => {
              this.$message({
                showClose: true,
                message: '产品发布成功',
                type: 'success'
              })
              window.location.reload()
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSuccess(res, file) {
      this.ruleForm.img_ids.push(res.data.id)
    },
    openHonme() {
      if (this.$route.path != '/index') {
        this.$router.push({ path: '/index' })
      }
    },
    open(item) {
      // console.log(item)
      let path = this.$route.path
      if (path == '/index') {
        this.$router.push({
          path: '/detail'
        })
        this.$emit('changeMsg', this.text, this.num)
      }
    },
    login() {
      this.$router.push({
        path: '/index'
      })
    },
    change(val) {
      this.ruleForm.memo = val
      console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-img {
  width: 1200px;
  margin: 0 auto;
}
.nav-img img {
  width: 400px;
  height: 300px;
  margin-top: -80px;
}
.logo-title {
  /* margin-top: -150px; */
  color: #fc6720;
  float: right;
  position: absolute;
  left: 450px;
  top: 60px;
  font-size: 22px;
}
.form-con {
  width: 1200px;
  margin: 0 auto;
  margin-top: -80px;
}
.release-title {
  background-color: #107a53;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  padding-left: 30px;
  margin-bottom: 20px;
}
.el-button--primary {
  background-color: #107a53;
  border: none;
}
.el-button--primary:hover {
  background-color: #fc6720;
}
.nav-btn {
  float: right;
  position: absolute;
  top: 50px;
  right: 450px;
}
.release-title {
  background-color: #107a53;
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  padding-left: 30px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/release.vue